<template>
  <div>
    <mdb-container class="mt-5 pt-5">
      <mdb-row>
        <mdb-col class="text-center">
          <div class="checkout-title text-center">
            <img src="/img/icons/ok.svg" style="width: 250px; height: auto;" alt />
            <h1 class="mt-5 t1-title">SU PAGO HA SIDO REALIZADO.</h1>
            <p class="t1-subtitle col-md-8 offset-md-2 text-justify">
              Estimado Solicitante,
              <b>{{ data.name.toUpperCase() }}</b> su pago de trámite de admisión ha sido realizado, hemos enviado a tu
              correo electrónico el comprobante de pago.
            </p>
            <p class="t1-subtitle col-md-8 offset-md-2 text-justify">
              Esta transacción aparecerá en su estado de cuenta como:
              <b>NETPAY*CLUB GOLF 3 MA.</b>
            </p>
            <div style="margin-top: 50px;">
              <router-link router to="/home"
                style="color: grey; text-decoration: none; font-size: 24px; font-weight: 600; ">Aceptar</router-link>
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <Loader v-show="isLoading" />
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapGetters, mapActions } from "vuex";
import Loader from "../../components/core/Loader";
import Swal from "sweetalert2";
export default {
  name: "PaymentDone",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Loader
  },
  data() {
    return {
      isLoading: true
    }

  },
  methods: {
    ...mapActions([
      "setPaymentDoneAgain",
      "postStep2",
      "postStep3",
      "sendInvestigation",
      "checkApplication"
    ]),
    async callMethods() {
      try {
        //     await this.setPaymentDoneAgain(true);
        // if(this.proceedingData.proceedingTypeId){
        //     await this.postStep2(this.proceedingData);
        //     await this.checkApplication();  
        // }
        // else {
        //   //console.log("No se guardo correctamente los datos del pago")
        //   throw "Error no se guardaron correctamente los datos del pago"
        // }


        // if (this.application.applicantType.applicantTypeValue == "Propietario" && this.application.subProceedingType && this.application.subProceedingType.subProceedingTypeValue =='Traspaso') {

        //   await this.postStep3(this.ownerDocuments);
        // }



        if (this.maritalStatus != "MARRIED" || this.application.membership.membershipName != "Familiar") {
          let data = {};
          data.considerApplicant = true;
          data.considerSpouse = false;
          let response = await this.sendInvestigation(data);
          if (response.data.status == 201) {
            this.isLoading = false
            // Swal.fire({
            //   title:
            //     "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #828282'>¡ENVÍO DE DATOS EXITOSO!</span>",
            //   html:
            //     "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
            //     "<p>Los datos han sido enviados correctamente. Espera indicaciones del Club para continuar con el proceso, revisa tu correo constantemente.</p>" +
            //     // "<p style='font-weight: 600;'>Recibirás respuesta de tu solicitud en un plazo aproximado de tres semanas</p>" +
            //     "<p style='padding-top: 1rem;'> <img src='/img/icons/sent-code.svg' alt='sendEmail'/> </p>" +
            //     "</div>",
            //   allowOutsideClick: false,
            //   width: "50rem",
            //   padding: "2rem",
            //   confirmButtonText: "Ok",
            //   confirmButtonColor: "#dc7134",
            //   customClass: {
            //     confirmButton: "t1-btn t1-btn--primary-block"
            //   },
            //   onClose: () => { }
            // });
          }
        }
        else {
          this.isLoading = false
        }

      } catch (error) {
        this.isLoading = false
        this.$notify.error({
          message: error.response.data.errorDetails,
          position: "top right",
          timeOut: 5000
        });

      }

    }
  },
  async mounted() {
    localStorage.setItem("payment_approved", true);
    await this.checkApplication();
    this.callMethods();

    //this.$store.commit("setPaymentApproved", true);
  },
  computed: {
    ...mapGetters({
      pdd: "getPaymentDoneData",
      maritalStatus: "getMaritalStatus",
      proceedingData: "getProceedingData",
      ownerDocuments: "getOwnerDocs",
      application: "getApplication"
    }),
    data() {
      return JSON.parse(this.pdd);
    }
  }
};
</script>